import { Document, Image, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import refertoImage from '../../resources/referto.jpg';
import qrcode from 'qrcode-generator';

    
const RefertoPDF = ({squadre, partite}) => {

const refertoStyles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: '#FFFFFF',
        position: 'relative',
        width: '100%',
        height: '100%',
    },
    backgroundImage: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        objectFit: 'fill',
    },
    squadreContainer1: {
        position: 'absolute',
        top: 12.5,
        left: 5,
    },
    squadreContainer2: {
        position: 'absolute',
        top: 12.5,
        left: 435,
    },
    squadreContainerGirone: {
        position: 'absolute',
        top: 12.5,
        left: 640,
    },
    squadreContainer3: {
        position: 'absolute',
        top: 12.5,
        left: 715,
    },
    squadreContainer4: {
        position: 'absolute',
        top: 12.5,
        left: 780,
    },
    squadraText: {
        fontSize: 12,
        color: '#000000',
    },
    giocatoriSquadra1: {
        position: 'absolute',
        top: 53,
        left: 1,
        flexDirection: 'column',
    },
    giocatoriSquadra2: {
        position: 'absolute',
        top: 53,
        left: 431,
        flexDirection: 'column',
    },
    giocatoreRow: {
        flexDirection: 'row',
        marginBottom: 3.9,
    },
    numeroCol: {
        width: 14,
        fontSize: 10,
        color: '#000000',
        textAlign: 'center',
    },
    magliaCol: {
        width: 100,
        fontSize: 10,
        color: '#000000',
        marginLeft: 5
    },
    qrPage: {
        flexDirection: 'column',
        backgroundColor: '#FFFFFF',
        padding: 20,
        width: 842,
        height: 595,
    },
    qrTable: {
        flexDirection: 'column',
        width: 802,
        height: 555,
    },
    qrRow: {
        flexDirection: 'row',
        height: 185,
        width: '100%',
    },
    qrCell: {
        width: 160.4,
        height: 185,
        padding: 10,
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexDirection: 'column',
    },
    qrCode: {
        width: 120,
        height: 120,
        marginBottom: 15,
        alignSelf: 'center',
    },
    qrText: {
        fontSize: 9,
        textAlign: 'center',
        color: '#000000',
        marginBottom: 3,
        width: '100%',
    }
});

const generateQRCodeDataURL = (text) => {
    const qr = qrcode(0, 'M');
    qr.addData(text);
    qr.make();
    
    // Create canvas to generate PNG
    const canvas = document.createElement('canvas');
    const size = 120;
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    
    const modules = qr.getModuleCount();
    const cellSize = size / modules;
    
    // Fill white background
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0, 0, size, size);
    
    // Draw QR modules
    ctx.fillStyle = '#000000';
    for (let row = 0; row < modules; row++) {
        for (let col = 0; col < modules; col++) {
            if (qr.isDark(row, col)) {
                const x = col * cellSize;
                const y = row * cellSize;
                ctx.fillRect(x, y, cellSize, cellSize);
            }
        }
    }
    
    return canvas.toDataURL('image/png');
};


return(
    <Document>
        {partite.map(partita => 
            (partita && partita.campo &&
            <Page size={[842, 595]} style={refertoStyles.page}>
                <Image style={refertoStyles.backgroundImage} src={refertoImage} />
                <View style={refertoStyles.squadreContainer1}>
                    <Text style={refertoStyles.squadraText}>{partita?.squadra1?.nome}</Text>
                </View>
                <View style={refertoStyles.squadreContainer2}>
                    <Text style={refertoStyles.squadraText}>{partita?.squadra2?.nome}</Text>
                </View>
                <View style={refertoStyles.squadreContainerGirone}>
                    <Text style={refertoStyles.squadraText}>{partita?.nome}</Text>
                </View>
                <View style={refertoStyles.squadreContainer3}>
                    <Text style={refertoStyles.squadraText}>{partita?.campo}</Text>
                </View>
                <View style={refertoStyles.squadreContainer4}>
                    <Text style={refertoStyles.squadraText}>{partita?.turno}</Text>
                </View>
                <View style={refertoStyles.giocatoriSquadra1}>
                    {partita?.squadra1?.giocatori?.sort((a, b) => a.numero - b.numero)?.map((giocatore, index) => (
                        <View key={index} style={refertoStyles.giocatoreRow}>
                            <Text style={refertoStyles.numeroCol}>{giocatore.numero}</Text>
                            <Text style={refertoStyles.magliaCol}>{giocatore.maglia}</Text>
                        </View>
                    ))}
                </View>
                <View style={refertoStyles.giocatoriSquadra2}>
                    {partita?.squadra2?.giocatori?.sort((a, b) => a.numero - b.numero)?.map((giocatore, index) => (
                        <View key={index} style={refertoStyles.giocatoreRow}>
                            <Text style={refertoStyles.numeroCol}>{giocatore.numero}</Text>
                            <Text style={refertoStyles.magliaCol}>{giocatore.maglia}</Text>
                        </View>
                    ))}
                </View>
            </Page>
        ))}
        {[...new Set(partite.map(p => p.campo))].map(campo => {
            if(campo == undefined)
                return <></>;

            const partiteCampo = partite.filter(p => p.campo === campo);
            const rows = [];
            
            for (let rowIndex = 0; rowIndex < 3; rowIndex++) {
                const cells = [];
                for (let colIndex = 0; colIndex < 5; colIndex++) {
                    const turnoIndex = rowIndex * 5 + colIndex;
                    const partita = partiteCampo.find(p => p.turno == turnoIndex+1);

                    var s1 = squadre.find(s => s.nome === partita?.squadra1.nome);
                    var s2 = squadre.find(s => s.nome === partita?.squadra2.nome);
                    
                    var url = `https://www.scoutballitalia.it/admin/refertotablet?s1=${s1?.hash}&s2=${s2?.hash}&nome=${partita?.nome ?? "?"}`
                    

                    cells.push(
                        <View key={`${rowIndex}-${colIndex}`} style={refertoStyles.qrCell}>
                            {partita ? (
                                <>
                                    <Image style={refertoStyles.qrCode} src={generateQRCodeDataURL(url)} />
                                    <Text style={refertoStyles.qrText}>{partita.squadra1?.nome || 'Squadra 1'} vs {partita.squadra2?.nome || 'Squadra 2'}</Text>
                                    <Text style={refertoStyles.qrText}>Turno: {partita.turno} Campo: {campo}</Text>
                                    <Text style={refertoStyles.qrText}>Fase: {partita.nome}</Text>
                                </>
                            ) : (
                                <Text style={{...refertoStyles.qrText, color: '#ccc'}}>Turno {turnoIndex}</Text>
                            )}
                        </View>
                    );
                }
                
                rows.push(
                    <View key={rowIndex} style={refertoStyles.qrRow}>
                        {cells}
                    </View>
                );
            }
            
            return (
                <Page key={campo} size={[842, 595]} style={refertoStyles.qrPage}>
                    <View style={refertoStyles.qrTable}>
                        {rows}
                    </View>
                </Page>
            );
        })}
    </Document>
);
}
export default RefertoPDF;